export default {
    mapGeofenceSettings_geofences: "Geofences",
    mapGeofenceSettings_units: "Units",
    mapGeofenceSettings_groups: "Groups"
};